import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Merge Tailwind classes with clsx — standard shadcn/ui utility */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
